<div class="page-container">
  <div class="page-header">
    <div class="header-icon">
      <mat-icon>account_balance_wallet</mat-icon>
    </div>
    <div class="header-text">
      <h1>Accounting</h1>
      <p>Manage financial transactions and records</p>
    </div>
  </div>

  <div class="landing-grid">
    <a routerLink="/account" class="landing-card">
      <div class="card-icon"><mat-icon>account_balance</mat-icon></div>
      <div class="card-text">
        <h3>Account</h3>
        <p>Chart of accounts management</p>
      </div>
    </a>
    <a routerLink="/account_receipt" class="landing-card">
      <div class="card-icon"><mat-icon>receipt_long</mat-icon></div>
      <div class="card-text">
        <h3>Account Receipt</h3>
        <p>Payment receipts and collections</p>
      </div>
    </a>
    <a routerLink="/note" class="landing-card">
      <div class="card-icon"><mat-icon>note_alt</mat-icon></div>
      <div class="card-text">
        <h3>Credit/Debit Note</h3>
        <p>Issue credit and debit notes</p>
      </div>
    </a>
    <a routerLink="/knock_off" class="landing-card">
      <div class="card-icon"><mat-icon>check_circle</mat-icon></div>
      <div class="card-text">
        <h3>Knock Off</h3>
        <p>Account knock-off entries</p>
      </div>
    </a>
    <a routerLink="/sales_return" class="landing-card">
      <div class="card-icon"><mat-icon>assignment_return</mat-icon></div>
      <div class="card-text">
        <h3>Sales Return</h3>
        <p>Process sales returns</p>
      </div>
    </a>
    <a routerLink="/proforma" class="landing-card">
      <div class="card-icon"><mat-icon>description</mat-icon></div>
      <div class="card-text">
        <h3>Proforma</h3>
        <p>Proforma invoices</p>
      </div>
    </a>
    <a routerLink="/invoice" class="landing-card">
      <div class="card-icon"><mat-icon>receipt</mat-icon></div>
      <div class="card-text">
        <h3>Invoice</h3>
        <p>Tax invoices and billing</p>
      </div>
    </a>
    <a routerLink="/journal_voucher" class="landing-card">
      <div class="card-icon"><mat-icon>menu_book</mat-icon></div>
      <div class="card-text">
        <h3>Journal Voucher</h3>
        <p>Journal entries and adjustments</p>
      </div>
    </a>
    <a routerLink="/balance" class="landing-card">
      <div class="card-icon"><mat-icon>account_balance_wallet</mat-icon></div>
      <div class="card-text">
        <h3>Opening Balance</h3>
        <p>Set opening balances</p>
      </div>
    </a>
  </div>
</div>
